import { USER_LOGIN_REQUEST,
    USER_LOGIN_SUCCESS,
    USER_LOGIN_FAIL,
    
    USER_LOGOUT,

    USER_REGISTER_REQUEST,
    USER_REGISTER_SUCCESS,
    USER_REGISTER_FAIL,

    USER_DETAILS_REQUEST,
    USER_DETAILS_SUCCESS,
    USER_DETAILS_FAIL,
    USER_DETAILS_RESET,

    USER_UPDATE_PROFILE_REQUEST,
    USER_UPDATE_PROFILE_SUCCESS,
    USER_UPDATE_PROFILE_FAIL,
    USER_UPDATE_PROFILE_RESET,

    USER_LIST_REQUEST,
    USER_LIST_SUCCESS,
    USER_LIST_FAIL,
    USER_LIST_RESET,

    USER_UPDATE_REQUEST,
    USER_UPDATE_SUCCESS,
    USER_UPDATE_FAIL,
    USER_UPDATE_RESET,

    USER_DELETE_REQUEST,
    USER_DELETE_SUCCESS,
    USER_DELETE_FAIL,

     } from "../constants/userConstants";
import axios from "axios";
import { ORDER_LIST_MY_RESET } from "../constants/orderConstants";


export const login = (email, password) => async(dispatch) =>{
    try{
        dispatch({
            type:USER_LOGIN_REQUEST

        })
        const config = {
            headers:{
                'Content-type':'application/json'
            }
        }
        const {data} = await axios.post(
            'https://fullstack-store.onrender.com/api/users/login/',
            {'username':email, 'password':password},
            config
        )
        dispatch({
            type:USER_LOGIN_SUCCESS,
            payload:data
        })

        localStorage.setItem('user', JSON.stringify(data))
    }
    catch(error){ 
        console.log(error.response.data.detail)
        dispatch({
        type:USER_LOGIN_FAIL,
        payload: error.response && error.response.data.detail
        ? error.response.data.detail
        : error.message,
    })}
}


export const logout = () => (dispatch) => {
    localStorage.removeItem('user')
    dispatch({type:USER_LOGOUT})
    dispatch({type:USER_DETAILS_RESET})
    dispatch({type:ORDER_LIST_MY_RESET})
    dispatch({type:USER_LIST_RESET})

}

export const register = (name, email, password) => async(dispatch) =>{
    try{
        dispatch({
            type:USER_REGISTER_REQUEST

        })
        const config = {
            headers:{
                'Content-type':'application/json'
            }
        }
        const {data} = await axios.post(
            'https://fullstack-store.onrender.com/api/users/register',
            {'name':name, 'email':email, 'password':password},
            config
        )
        dispatch({
            type:USER_REGISTER_SUCCESS,
            payload:data
        })
        dispatch({
            type:USER_LOGIN_SUCCESS,
            payload:data
        })

        localStorage.setItem('user', JSON.stringify(data))
    }
    catch(error){dispatch({
        type:USER_REGISTER_FAIL,
        payload: error.response && error.response.data.message
        ? error.response.data.message
        : error.message,
    })}
}

export const getUserDetails = (id) => async(dispatch, getState) =>{
    try{
        dispatch({
            type:USER_DETAILS_REQUEST

        })
        const {
            userLogin: {user}
        } = getState()
        const config = {
            headers:{
                'Content-type':'application/json',
                Authorization: `Bearer ${user.token}`
            }
        }
        const {data} = await axios.get(
            `https://fullstack-store.onrender.com/api/users/${id}/`,
            config
        )
        dispatch({
            type:USER_DETAILS_SUCCESS,
            payload:data
        })
        

    }
    catch(error){dispatch({
        type:USER_DETAILS_FAIL,
        payload: error.response && error.response.data.message
        ? error.response.data.message
        : error.message,
    })}
}

export const updateUserProfile = (useri) => async(dispatch, getState) =>{
    try{
        dispatch({
            type:USER_UPDATE_PROFILE_REQUEST

        })
        const {
            userLogin: {user}
        } = getState()
        console.log('user:', user)
        const config = {
            headers:{
                'Content-type':'application/json',
                Authorization: `Bearer ${user.token}`
            }
        }
        const {data} = await axios.put(
            `https://fullstack-store.onrender.com/api/users/profile/update/`,
            useri,
            config
        )
        dispatch({
            type:USER_UPDATE_PROFILE_SUCCESS,
            payload:data
        })

        dispatch({
            type: USER_LOGIN_SUCCESS,
            payload:data
        })
        localStorage.setItem('user', JSON.stringify(data))
        

    }
    catch(error){dispatch({
        type:USER_UPDATE_PROFILE_FAIL,
        payload: error.response && error.response.data.message
        ? error.response.data.message
        : error.message,
    })}
}


export const getUsersList = (id) => async(dispatch, getState) =>{
    try{
        dispatch({
            type:USER_LIST_REQUEST

        })
        const {
            userLogin: {user}
        } = getState()

        const config = {
            headers:{
                'Content-type':'application/json',
                Authorization: `Bearer ${user.token}`
            }
        }
        const {data} = await axios.get(
            `https://fullstack-store.onrender.com/api/users/`,
            config
        )
        dispatch({
            type:USER_LIST_SUCCESS,
            payload:data
        })
        

    }
    catch(error){dispatch({
        type:USER_LIST_FAIL,
        payload: error.response && error.response.data.message
        ? error.response.data.message
        : error.message,
    })}
}


export const deleteUser = (id) => async(dispatch, getState) =>{
    try{
        dispatch({
            type:USER_DELETE_REQUEST

        })
        const {
            userLogin: {user}
        } = getState()

        const config = {
            headers:{
                'Content-type':'application/json',
                Authorization: `Bearer ${user.token}`
            }
        }
        const {data} = await axios.delete(
            `https://fullstack-store.onrender.com/api/user/delete/${id}/`,
            config
        )
        dispatch({
            type:USER_DELETE_SUCCESS,
            payload:data
        })
        

    }
    catch(error){dispatch({
        type:USER_DELETE_FAIL,
        payload: error.response && error.response.data.message
        ? error.response.data.message
        : error.message,
    })}
}

export const updateUser = (User) => async(dispatch, getState) =>{
    try{
        dispatch({
            type:USER_UPDATE_REQUEST

        })
        const {
            userLogin: {user}
        } = getState()

        const config = {
            headers:{
                'Content-type':'application/json',
                Authorization: `Bearer ${user.token}`
            }
        }
        const {data} = await axios.put(
            `https://fullstack-store.onrender.com/api/user/update/${User._id}/`,
            User,
            config
        )
        dispatch({
            type:USER_UPDATE_SUCCESS,
        })

        dispatch({
            type:USER_DETAILS_SUCCESS,
            payload: data,
        })
        

    }
    catch(error){dispatch({
        type:USER_UPDATE_FAIL,
        payload: error.response && error.response.data.message
        ? error.response.data.message
        : error.message,
    })}
}